












































































































































import {Component, Prop, Vue} from "vue-property-decorator";
import {MerchantCircle} from "@/entity/MerchantCircle";
import {MerchantCircleDto} from "@/dto/MerchantCircleDto";
import {UserDto} from "@/oauth/UserDto";
import {getModule} from "vuex-module-decorators";
import {AuthStore} from "@/oauth/AuthStore";
import {User} from "@/oauth/User";
import {CollectCompany} from "@/entity/CollectCompany";
import {CollectCompanyDto} from "@/dto/CollectCompanyDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Validation} from "@/utils/Validation";
import {JiGuangDto} from "@/dto/JiGuangDto";
import {MessageJiGuangUserBody} from "@/entity/MessageJiGuangUserBody";
import {ClientPage} from "@/entity/ClientPage";
import {CircleManagementDto} from "@/dto/CircleManagementDto";
import {CircleManagement} from "@/entity/CircleManagement";
import { QueryList } from "@/utils/QueryList";
import {UserInfoEntity} from "@/entity/UserInfoEntity";
import {CompanyInfo} from "@/entity/CompanyInfo";


@Component({
  components: {},
})

export default class TieZiView extends Vue {
  @Prop({default: () => []})
  jieShouQTree !: MerchantCircle[]

  saveQTree = new MerchantCircle();
  dialog = false
  lingShiCunFangQTree = new MerchantCircle()


  ls = getModule(AuthStore);
  collectCompany = new CollectCompany()
  su = SecurityUtils;
  imageDialog = false
  cunfangImageUrl = ''
  private Validation = Validation;
  loading = false
  disable = false
  filterString: string [] = [];//屏蔽关键字
  articleDeletionConfirmation = false
  deleteId: string | undefined
  deleteUserId: string | undefined


 merchantReply(circleManagement: CircleManagement){
   this.storeCircleManagement = circleManagement
   this.isReply = false
   this.dialog = true
 }

  isReply: any
  done: any
  saveCircleManagement = new CircleManagement()
  storeCircleManagement = new CircleManagement()
  @Prop({default: () => []})
  public circleManagementList!: CircleManagement[]
  public realCircleManagement: QueryList<CircleManagement> = new QueryList();
  onLoadCircleManagement(index: any , done: any){
   setTimeout(async () => {
     const clientPage = new ClientPage()
     if (this.circleManagementList.length==0){
       clientPage.page = index
     }else {
       clientPage.page = index+1
     }
     clientPage.size = '20'
     console.log(clientPage.page)
     const a = await CircleManagementDto.queryCircleManagementPageList(clientPage)
     console.log(a);
     if (a.length<=0){
       done(true)
     }else {
       for (let i=0; i<a.length;i++){
         this.circleManagementList.push(a[i])
       }
       console.log(this.circleManagementList);
       done()
     }
   },2000)
  }


  openImageDialog(url: string) {
    this.imageDialog = true
    this.cunfangImageUrl = url;
  }

  // replaceTime(time: string) {
  //   const data = new Date(time).toJSON();
  //   // const str1 = time.replace("T", " ")
  //   // const str2 = str1.slice(0, 20)
  //   const creationTimeStr = new Date(+new Date(data) + 22 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  //   return creationTimeStr
  // }

  async findAllCompanyName() {
    const id = this.su.getLoginUser().id as number;
    this.collectCompany = await CollectCompanyDto.findById(id)
  }

  filter(msg: string) {
    const a = new RegExp(this.filterString.join('|'), 'g');
    return msg.replace(a, '*');
  }

  async save() {
    if (this.saveCircleManagement.userMessage != '') {
      // await this.findAllCompanyName();
      const a = await MerchantCircleDto.getKeyWords();
      a.forEach(value => {
        this.filterString.push(value.message);
      });
      this.saveCircleManagement.userMessage = this.filter(this.saveCircleManagement.userMessage);//过滤
      const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
      try {
        this.loading = true
        this.disable = true
        this.saveCircleManagement.userId = this.ls.loginUser.username
        this.saveCircleManagement.userName = this.ls.loginUser.name
        /*
        const userInfoEntity = JSON.parse(localStorage.getItem("demo1") as any)
        let a = new UserInfoEntity()
        a  =userInfoEntity
        if (a.companyName != null){
          this.saveCircleManagement.userCompany = a.companyName
        }else {
          this.saveCircleManagement.userCompany = ''
        }
         */
        const companyInfo = JSON.parse(localStorage.getItem("selectedCompanyInfo") as any) as CompanyInfo;
        if (companyInfo.companyName != null){
          this.saveCircleManagement.userCompany = companyInfo.companyName
        }else {
          this.saveCircleManagement.userCompany = ''
        }

        this.saveCircleManagement.isReply = this.isReply
        this.saveCircleManagement.parentId = this.storeCircleManagement.id
        this.saveCircleManagement.replyId = this.storeCircleManagement.id
        this.saveCircleManagement.replyUserName = this.storeCircleManagement.userName
        const  insertCircleManagement = await CircleManagementDto.insertCircleManagementPageList(this.saveCircleManagement)
        if (insertCircleManagement.resCode ==0 ){
          nf({type: 'positive', message: '发送成功', timeout: 1500});
          const informationToShow = new MessageJiGuangUserBody();
          informationToShow.jidUsername = this.storeCircleManagement.parentId as string
          informationToShow.name = this.ls.loginUser.name
          informationToShow.message = "在帖子中回复您  " + this.storeCircleManagement.userMessage
          await JiGuangDto.sendMessage(informationToShow)
        }else {
          nf({type: 'negative', message: '发送失败:' , timeout: 4000});
        }
        const clientPage = new ClientPage()
        clientPage.page = '1'
        clientPage.size = '20'
        const queryCircleManagementPageList = await CircleManagementDto.queryCircleManagementPageList(clientPage)
        this.circleManagementList =[]
        for (let i=0; i<queryCircleManagementPageList.length;i++){
          this.circleManagementList.push(queryCircleManagementPageList[i])
        }
        this.loading = false
        this.disable = false
        this.dialog = false
        console.log(insertCircleManagement);
        console.log(this.saveCircleManagement);
      } catch (e) {
        this.loading = false;
        this.disable = false
        nf({type: 'negative', message: '发送失败:' + e, timeout: 4000});
      }
    }
  }

  async deleteChild(c: MerchantCircle, child: MerchantCircle) {
    await MerchantCircleDto.delete(child.id as number)
    this.jieShouQTree = await MerchantCircleDto.accurateSelectQTree()
  }

  showDeleteDialog(id: string,userId: string){
    this.articleDeletionConfirmation = true
    this.deleteId = id;
    this.deleteUserId=userId;

  }
  async deleteParent(id: string,userId: string) {
    if (this.ls.loginUser.username == userId) {
      await MerchantCircleDto.delete(Number(id))
    } else {
      this.$q.notify({message: '您不是发表本贴的用户无法删除'});
    }
    const clientPage = new ClientPage()
    clientPage.page = '1'
    clientPage.size = '20'
    const a = await CircleManagementDto.queryCircleManagementPageList(clientPage)
    this.circleManagementList =[]
    for (let i=0; i<a.length;i++){
      this.circleManagementList.push(a[i])
    }
    this.articleDeletionConfirmation= false
  }

  huiFu(qTree: MerchantCircle) {
    this.lingShiCunFangQTree = qTree
    this.dialog = true
  }

  huiFuChild(circleManagement: CircleManagement) {
    this.storeCircleManagement =circleManagement
    this.isReply = true
    this.dialog = true
  }
  closeImage(){
    console.log("2222222222222")
    this.imageDialog = false
  }

  // private async mounted() {
  //
  // }
}
